<div class="music-tool row">
  <div
    id="waveform-wrapper"
    class="col-md-8"
    [ngClass]="{ loading: state == 'loading' }"
    >
    @if (!waveSurfer || state == 'initialized' || state == 'loading') {
      <app-play-button
        [loading]="state == 'initializing' || state == 'loading'"
        (click)="generateWaveform()"
        [disabled]="!generateable"
      ></app-play-button>
    }
    @if (message) {
      <div id="message">{{ message }}</div>
    }
    <!-- <app-loading-indicator></app-loading-indicator> -->
    <div id="waveform"></div>
    <div id="controls">
      <button
        class="btn btn-light m-1"
        (click)="state == 'playing' ? pause() : state == 'paused'? play() : generateWaveform() "
        [disabled]="!generateable"
        >
        @if (state=='playing') {
          <i class="fas fa-pause"></i>
        }
        @if (state=='paused') {
          <i class="fas fa-play"></i>
        }
        @if (state != 'playing' && state != 'paused') {
          <span>Start</span>
        }
      </button>
      <button
        class="btn btn-light m-1"
        (click)="reset()"
        [disabled]="disableResetBtn"
        >
        Reset
      </button>
      <!-- <button
      class="btn btn-dark m-1"
      (click)="generateWaveform()"
      [disabled]="disableGenerateBtn"
      >
      {{ state == "initializing" ? "Loading..." : "Generate" }}
    </button> -->
  </div>
</div>

<div id="musical-elements" class="col-md-4">
  <span id="good-label">Opportunities</span>
  @for (el of elements; track el; let i = $index) {
    @if (el.sentiment == 'good') {
      <button
        [class]="el.sentiment"
        (click)="toggle(i)"
        [ngClass]="{ active: audioQueue.includes(i) }"
        [matTooltip]="el.instrument"
        matTooltipPosition="above"
        (mouseenter)="setMessage(el.description)"
        (mouseleave)="resetMessage()"
        [disabled]="state=='loading'"
        >
        {{ el.name }}
      </button>
    }
  }

  <span id="bad-label">Obstacles</span>
  @for (el of elements; track el; let i = $index) {
    @if (el.sentiment == 'bad') {
      <button
        [class]="el.sentiment"
        (click)="toggle(i)"
        [ngClass]="{ active: audioQueue.includes(i) }"
        [matTooltip]="el.instrument"
        matTooltipPosition="above"
        (mouseenter)="setMessage(el.description)"
        (mouseleave)="resetMessage()"
        [disabled]="state=='loading'"
        >
        {{ el.name }}
      </button>
    }
  }
</div>
</div>
